/*
 * @Description: 试戴相关接口
 * @FilePath: \vooglam-pc-vue\src\api\modules2\try-on.js
 * @Author: 王逢超 wangfengchao@nextmar.com
 * @Date: 2022-10-22 16:28:04
 */
import normalAxios from 'axios'
import qs from 'qs'
// 试戴接口的域名，只有一个正式环境，没有测试环境
const ORIGIN = 'https://tryon.nextmar.com'

export default {
    /* 试戴上传图片并获取定位信息 */
    uploadTryOnImg (data) {
        return normalAxios.post(`${ORIGIN}/api/tryon/photo_upload_base64`, qs.stringify(data))
    },
    // 把试戴图片和用户绑定起来
    bindImg: data => normalAxios.post(`${ORIGIN}/api/tryon/save_guest_image`, data),
    delImg: data => normalAxios.get(`${ORIGIN}/api/tryon/delete_customer_image?${qs.stringify(data)}`),
    getImg: data => normalAxios.get(`${ORIGIN}/api/tryon/get_customer_image?${qs.stringify(data)}`),

}
